<template>
  <div>
    <form>
      <b-form-group>
        <label for="from_extra" v-translate>Place ID</label>
        <div class="input-group">
          <b-form-input v-model="placeId"
            type="number"
          ></b-form-input>
        </div>
      </b-form-group>
      <b-form-group>
        <b-button variant="primary" @click.prevent="placeIdCheck" v-translate>
          Search
        </b-button>
      </b-form-group>
      <div v-if="this.theCheckedAddress.id">
        <p><font-awesome-icon size="1x" icon="map-marker" color="red" /> {{theCheckedAddress.formatted_address}}</p>
        <h2>
          <translate>In area?</translate>
          <span v-if="this.theCheckedAddress.in_area" class="text-success" v-translate>YES</span>
          <span v-else class="text-danger" v-translate>NO</span>
        </h2>
        <div v-if="theCheckedArea.id"><hr>
          <span v-translate="{data: theCheckedArea.id}">ID: <strong>%{data}</strong></span><br>
          <span v-translate="{data: theCheckedArea.name}">Name: <strong>%{data}</strong></span><br>
          <translate>Is Dangerous?</translate>
          <strong v-if="theCheckedArea.is_dangerous" class="text-danger" v-translate>YES</strong>
          <strong v-else v-translate>NO</strong>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
export default {
  name: 'PlaceIdCheck',
  data() {
    return {
      placeId: null,
      ignoreArea: true,
      theCheckedArea: {}
    }
  },
  mixins: [AddressMixins],
  methods: {
    async placeIdCheck() {
      let item = {
        id: this.placeId
      }
      this.theCheckedArea = {}
      this.theCheckedAddress = {}
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          console.log(this.theCheckedAddress)
          if (this.theCheckedAddress.in_area) {
            this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + this.theCheckedAddress.in_area.id)
              .then(response => {
                console.log(response.body)
                this.theCheckedArea = response.body
              })
          }
        }
      })
    }
  }
}
</script>
